var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5583 0.241212C28.21 0.241212 25.2178 1.98043 25.2178 5.19377C25.2178 8.87887 30.5246 9.1334 30.5246 10.9847C30.5246 11.7642 29.6332 12.462 28.1107 12.462C25.95 12.462 24.3352 11.487 24.3352 11.487L23.6442 14.7296C23.6442 14.7296 25.5045 15.5532 27.9744 15.5532C31.6351 15.5532 34.5157 13.7285 34.5157 10.4603C34.5157 6.56629 29.1868 6.31932 29.1868 4.60102C29.1868 3.99039 29.9186 3.32133 31.4366 3.32133C33.1495 3.32133 34.547 4.03042 34.547 4.03042L35.2233 0.898598C35.2233 0.898598 33.7027 0.241212 31.5583 0.241212ZM0.924582 0.477577L0.843506 0.950304C0.843506 0.950304 2.25214 1.20866 3.52084 1.72403C5.15441 2.315 5.27077 2.65903 5.54589 3.72758L8.54385 15.3094H12.5626L18.7538 0.477577H14.7443L10.7661 10.5618L9.1427 2.01394C8.99382 1.03564 8.23972 0.477577 7.31666 0.477577H0.924582ZM20.3661 0.477577L17.2208 15.3094H21.0442L24.1785 0.477577H20.3661ZM41.6909 0.477577C40.7689 0.477577 40.2804 0.972246 39.922 1.83667L34.3204 15.3094H38.3299L39.1057 13.064H43.9905L44.4622 15.3094H48L44.9136 0.477577H41.6909ZM42.2123 4.48468L43.4008 10.0503H40.2168L42.2123 4.48468Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1565,
    height: 15.2565,
    fill: "white",
    transform: "translate(0.843506 0.241211)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.95a708e7d383d6576b0ba3fdc3dbb565.svg";
export { ForwardRef as ReactComponent };